import {KEY_POINT_CONFIGS} from "../../configs/tokens";

export const checkIfKeyPoint = (tokenId) => {
  return KEY_POINT_CONFIGS.some(token => token.id === tokenId)
}